<template>
    <div>
        <el-card class="box-card box-cards" shadow="never">
            <el-row>
                <el-form :inline="true" class="user-search">
                    <el-col :span="24">
                        <el-form-item>
                            <div class="card_top"><span>打卡统计</span></div>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
        </el-card>
        <!-- <el-card class="box-card box-cards2"> -->
        <div class="xiayu">
            <el-card shadow="never">
                <div>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-card shadow="never" class="juzhong">
                                <div class="shuzi3">{{ tableData.monthlyDays }}</div>
                                <div class="title">本月打卡天数</div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="never" class="juzhong">
                                <div class="shuzi3">{{ tableData.monthlyDuration }}</div>
                                <div class="title">本月学习时长(分钟)</div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="never" class="juzhong">
                                <div class="shuzi3">{{ tableData.monthlyPoints }}</div>
                                <div class="title">本月获得积分</div>
                            </el-card>
                        </el-col>


                    </el-row>
                </div>
                <div style="margin-top: 20px;">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-card shadow="never" class="juzhong">
                                <div class="shuzi3">{{ tableData.monthlyWordCount }}</div>
                                <div class="title">本月学习单词数</div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="never" class="juzhong">
                                <div class="shuzi3">{{ tableData.streakDays }}</div>
                                <div class="title"> 连续打卡天数</div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="never" class="juzhong">
                                <div class="shuzi3">{{ tableData.totalDays }}</div>
                                <div class="title">总打卡天数</div>
                            </el-card>
                        </el-col>


                    </el-row>
                </div>
                <div style="margin-top: 20px;">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-card shadow="never" class="juzhong">
                                <div class="shuzi3">{{ tableData.totalDuration }}</div>
                                <div class="title"> 总学习时长(分钟)</div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="never" class="juzhong">
                                <div class="shuzi3">{{ tableData.totalPoints }}</div>
                                <div class="title">总获得积分</div>
                            </el-card>
                        </el-col>
                        <el-col :span="8">
                            <el-card shadow="never" class="juzhong">
                                <div class="shuzi3">{{ tableData.totalWordCount }}</div>
                                <div class="title"> 总学习单词数</div>
                            </el-card>
                        </el-col>

                    </el-row>
                </div>
            </el-card>
        </div>



    </div>
</template>
<script type="text/ecmascript-6">
import { checkinstats } from "../../api/userMG";
export default {
    data() {
        return {
            tableData: {}
        };
    },
    components: {
    },
    created() {
        this.getlist();
    },
    mounted() {
    },
    methods: {
        getlist() {
            checkinstats({
                "data": {},
                "params": {},
            })
                .then((res) => {
                    this.tableData = res.data;
                    //console.log("111", res);

                })
                .catch((err) => {
                    this.loading = false;
                    // this.$message.error("加载失败，请稍后再试！");
                });



        },


    },
};
</script>
<style scoped>
@import "../../assets/css/index.css";

.xiayu {
    margin-top: 20px;

    /* margin-bottom: 20px; */
}

.juzhong {
    text-align: center;
    padding: 10px;
}

.shuzi {
    color: rgb(231, 56, 56);
    font-size: 30px;
    font-weight: 600;
    line-height: 50px;
}

.title {
    color: rgb(94, 92, 92);
    font-size: 18px;
}

.shuzi1 {
    color: rgb(236, 233, 22);
    font-size: 30px;
    font-weight: 600;
    line-height: 50px;
}

.shuzi2 {
    color: rgb(56, 231, 129);
    font-size: 30px;
    font-weight: 600;
    line-height: 50px;
}

.shuzi3 {
    color: rgb(56, 152, 231);
    font-size: 30px;
    font-weight: 600;
    line-height: 50px;
}

.shuzi4 {
    color: rgb(46, 46, 45);
    font-size: 30px;
    font-weight: 600;
    line-height: 50px;
}

.gaodu {
    height: 450px;
}

.st-gbox {
    background-color: #fff;
    margin-top: 20px;
    border-radius: 5px;
    height: 350px;
    box-sizing: border-box;
    padding: 10px;
}

.cavasbox {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue